// `description` stays in English because the app matches on it (see
// hasUserParticipatedInProgram); the page renders `descriptionKey` /
// `rewardLabel*` through i18n and formats `date` at render time.
export const formatEntryHistoryItem = (entry) => {
    const createdAt = new Date(entry.timestamp || entry.createdAt);
    const validDate = Number.isFinite(createdAt.getTime());

    let description = "Shake for rewards";
    let descriptionKey = "entries.desc.default";
    let rewardLabel = null;
    let rewardLabelKey = null;
    let type = "deduction";
    let amount = 1;

    switch (entry.source) {
      case "daily_login":
        description = "Daily login bonus";
        descriptionKey = "entries.desc.dailyLogin";
        type = "gain";
        amount = entry.result?.dailyLoginValue || entry.shakeCount || 1;
        break;
      case "shake": {
        const granted = entry.result?.rewardGranted;
        if (granted) {
          if (entry.result?.rewardType === "voucher") {
            rewardLabel = "voucher";
            rewardLabelKey = "entries.rewardLabel.voucher";
          } else if (entry.result?.rewardType === "token") {
            // The token type is the token's own name from VIO; only the fallback is ours.
            rewardLabel = entry.result?.tokenType || "token";
            rewardLabelKey = entry.result?.tokenType ? null : "entries.rewardLabel.token";
          } else {
            rewardLabel = "reward";
            rewardLabelKey = "entries.rewardLabel.reward";
          }
          description = `Shake (won ${rewardLabel})`;
          descriptionKey = "entries.desc.shakeWon";
        } else {
          // Defensive: with the new backend, no-reward shakes are NOT recorded.
          description = "Shake (no reward)";
          descriptionKey = "entries.desc.shakeNoReward";
        }
        type = "deduction";
        amount = 1;
        break;
      }
      default:
        if (entry.source) {
          // Unknown source identifier from the API: shown title-cased as before.
          description = entry.source
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
          descriptionKey = null;
        }
        type = "deduction";
        amount = entry.shakeCount || 1;
        break;
    }

    return {
      id: entry.id,
      type,
      amount,
      description,
      descriptionKey,
      rewardLabel,
      rewardLabelKey,
      date: validDate ? createdAt.toISOString() : null,
      source: entry.source,
    };
  };
